/** @format */

import { useAppContext, FILTER_NAMES } from '../store/store.app';

export function getHotelDisplay(code) {
  const lowerCode = String(code || '')
    .trim()
    .toLowerCase();

  if (lowerCode === 'alembic') {
    return {
      name: 'Alembic',
      location: '',
    };
  }

  if (lowerCode === 'jw') {
    return {
      name: 'JW Marriott',
      location: 'Kolkata',
    };
  }

  if (lowerCode === 'cy siliguri' || lowerCode === 'cy_siliguri') {
    return {
      name: 'Courtyard by Marriott',
      location: 'Siliguri',
    };
  }

  return {
    name: '',
    location: '',
  };
}

export default function useHotelNames() {
  const {
    appStore: { appFilters },
  } = useAppContext();

  const params = appFilters?.[FILTER_NAMES.PARAMETER] || [];

  const hotelParam = params.find(
    (p) => String(p?.name || '').toLowerCase() === 'hotel'
  );

  const selectedHotels = Array.isArray(hotelParam?.selected)
    ? hotelParam.selected.filter(Boolean)
    : [];

  return selectedHotels
    .map((code) => getHotelDisplay(code))
    .filter((hotel) => hotel.name);
}

export function getHotelNamesLabel(hotels) {
  return hotels
    .map((hotel) =>
      hotel.location ? `${hotel.name} • ${hotel.location}` : hotel.name
    )
    .join('  &  ');
}

export function getHotelNamesHtml(hotels) {
  const blocks = hotels
    .map((hotel, i) => {
      const location = hotel.location
        ? `<span class="print-hotel-location"><span class="print-hotel-location-dot">•</span>${hotel.location}</span>`
        : '';

      const separator =
        i < hotels.length - 1
          ? '<span class="print-hotel-separator">&</span>'
          : '';

      return `
        <span class="print-hotel-block">
          <span class="print-hotel-name-text">${hotel.name}</span>
          ${location}
        </span>
        ${separator}
      `;
    })
    .join('');

  return `
    <span class="print-toolbar-divider"></span>
    ${blocks}
  `;
}

export function getHotelNamesCss() {
  return `
    .print-hotel-name {
      display: flex;
      align-items: center;
      min-width: 0;
      overflow: hidden;
    }

    .print-toolbar-divider {
      display: inline-block;
      width: 1px;
      height: 34px;
      background: #e5e7eb;
      margin: 0 24px 0 0;
      flex-shrink: 0;
    }

    .print-hotel-block {
      display: flex;
      flex-direction: column;
      min-width: 0;
    }

    .print-hotel-name-text {
      font-family: "Public Sans", sans-serif;
      font-size: 20px;
      font-weight: 700;
      color: #374151;
      line-height: 1.2;
      white-space: nowrap;
    }

    .print-hotel-location {
      font-family: "Public Sans", sans-serif;
      font-size: 11px;
      font-weight: 500;
      color: #6b7280;
      display: flex;
      align-items: center;
      gap: 4px;
    }

    .print-hotel-location-dot {
      color: #2d348d;
      font-size: 14px;
      line-height: 0;
    }

    .print-hotel-separator {
      margin: 0 20px;
      font-family: "Public Sans", sans-serif;
      font-size: 18px;
      font-weight: 300;
      color: #d1d5db;
      user-select: none;
    }
  `;
}
